"use client";

/**
 * NewForm DS icon — an indeterminate loading spinner.
 *
 * A faint full ring with a brighter arc rotating over it, so the glyph
 * still reads as a circle at rest instead of a lone floating stroke. The
 * only icon in this folder that animates unprompted; see ./hoverIcon for
 * the colour conventions it otherwise shares.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function LoadingIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <circle cx="12" cy="12" r="8.2" opacity={0.3} />
      <path className="a-spin" d="M20.2 12A8.2 8.2 0 0 0 12 3.8" />
    </HoverIconSvg>
  );
}
